import { SearchInput, useInputHelper } from 'framework/form';
import type { DefaultInputPropTypes } from 'framework/form';
import useRecruitmentPoolService from '../../useRecruitmentPoolService';
import { RECRUITMENT_POOL_STATUS } from '../../constants';
import { ASC } from 'framework/list';

type RecruitmentPoolInputProps = Omit<DefaultInputPropTypes<string>, 'source'> & {
  source?: string;
  initialLabel?: string;
  minSearchLength?: number;
  isInfinityLoading?: boolean;
};

const RecruitmentPoolInput = ({ source = 'recruitmentPoolId', ...props }: RecruitmentPoolInputProps) => {
  const { getValue } = useInputHelper({ source });
  const { search, getById } = useRecruitmentPoolService();
  const currentRecruitmentPoolId = getValue() as string | undefined;

  const getInitialLabel = async () => {
    if (!currentRecruitmentPoolId) return '';

    return (await getById(currentRecruitmentPoolId))?.name ?? currentRecruitmentPoolId;
  };

  return (
    <SearchInput
      {...props}
      source={source}
      searchString="name"
      searchRequest={params =>
        search({
          ...params,
          filter: {
            ...params.filter,
            status: { eq: RECRUITMENT_POOL_STATUS.ACTIVE },
          },
          sort: params.sort ?? { name: ASC },
        })
      }
      mapResults={pool => ({ id: pool.id, text: pool.name })}
      customGetInitialValue={currentRecruitmentPoolId ? getInitialLabel : undefined}
      noResultMessage="No active recruitment pools are found."
      placeholder="Recruitment pool"
      isInfinityLoading
    />
  );
};

export default RecruitmentPoolInput;
